/**
 * @flow
 * @relayHash 9f2473f1048d1ed3fecdd7d2cfd553c7
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ClientDetails_TriggerWecomeBack_MutationVariables = {|
  input: {
    travelerId?: ?string;
    clientMutationId?: ?string;
  };
|};

export type ClientDetails_TriggerWecomeBack_MutationResponse = {|
  +triggerWelcomeBack: ?{|
    +traveler: ?{|
      +welcomeBack: boolean;
    |};
  |};
|};
*/


/*
mutation ClientDetails_TriggerWecomeBack_Mutation(
  $input: TriggerWelcomeBackInput!
) {
  triggerWelcomeBack(input: $input) {
    traveler {
      welcomeBack
      id
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "TriggerWelcomeBackInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientDetails_TriggerWecomeBack_Mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "TriggerWelcomeBackInput!"
          }
        ],
        "concreteType": "TriggerWelcomeBackPayload",
        "name": "triggerWelcomeBack",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Traveler",
            "name": "traveler",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "welcomeBack",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ClientDetails_TriggerWecomeBack_Mutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "TriggerWelcomeBackInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "ClientDetails_TriggerWecomeBack_Mutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "TriggerWelcomeBackInput!"
          }
        ],
        "concreteType": "TriggerWelcomeBackPayload",
        "name": "triggerWelcomeBack",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Traveler",
            "name": "traveler",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "welcomeBack",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation ClientDetails_TriggerWecomeBack_Mutation(\n  $input: TriggerWelcomeBackInput!\n) {\n  triggerWelcomeBack(input: $input) {\n    traveler {\n      welcomeBack\n      id\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// /src/components/Clients/__generated__/ClientDetails_TriggerWecomeBack_Mutation.graphql.js